import {
  colors,
  MakeError,
  Makelabel,
  setLocalStorageItem,
} from "../../Utils/Index";
import { Form } from "antd";
import { useState } from "react";
import { RestaurentLogin } from "../../ApiService/Apis/Auth/Auth";
import CommonButton from "../../Components/CommonButton";
import CommonInput from "../../Components/CommonInput";
import { useNavigate } from "react-router-dom";
export default function Login() {
  const [showLoading, setsahowLaoding] = useState(false);
  const navigate = useNavigate();
  const handleFinish = (val) => {
    setsahowLaoding(true);
    RestaurentLogin(val)
      .then((res) => {
        if (res.status === "success") {
          setLocalStorageItem("access_token", res.data.access_token);
          setLocalStorageItem("userDetail", res.data.user);
          if (res.data.user.role === "kitchen") {
            navigate("/order-status");
          } else {
            navigate("/dashboard");
          }
          window.location.reload();
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setsahowLaoding(false));
  };
  return (
    <div className="  ">
      <div className="flex justify-center signInbg text-black m-auto h-full items-center">
        <div className="bg-[#26272cb3] w-[400px] flex justify-center flex-col px-8 py-6 m-4 items-center">
          <div className="flex justify-center items-center  text-dynmaicText">
            <p className="text-4xl font-quicksand font-semibold">
              Ezulix Restro
            </p>
          </div>
          <Form
            onFinish={(val) => handleFinish(val)}
            className="w-full mt-2"
            labelCol={{ span: 24 }}
          >
            <Form.Item
              rules={[{ required: true, message: MakeError("enter username") }]}
              className="w-full m-1"
              name={"loginId"}
              label={Makelabel("Username")}
            >
              <CommonInput placeholder={"Enter user name"} />
            </Form.Item>
            <Form.Item
              rules={[{ required: true, message: MakeError("enter password") }]}
              className="w-full"
              name={"password"}
              label={Makelabel("password")}
            >
              <CommonInput placeholder={"Enter password"} />
            </Form.Item>
            <Form.Item className="w-full ">
              <CommonButton
                loading={showLoading}
                margintop={"10px"}
                htmltype={"submit"}
                color={colors.green}
                text={"Login"}
              />
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}
